module.exports = __webpack_public_path__ + "static/img/bestimade_mini.adf977e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bestimade_mini.jpg
// module id = y7Yv
// module chunks = 4